//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Builder.js";
let d=[[[0,"Category",1,0],[0,"DecisionAction",1,0],[0,"DecisionUser",1,0],[0,"Reason",1,0],[0,"RequestType",1,0],[0,"ToState",1,0]],[[["nDetailReason"],"GetDetailReason",{R_:{detailReason:""}},0,0],[["detailReason"],"SetDetailReason",{},1,0],[["nDecisionComments"],"GetDecisionComments",{R_:{decisionComments:""}},0,0],[["decisionComments"],"SetDecisionComments",{},1,0]],[]];
SPLM.Validate.OverrideBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.OverrideBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.OverrideBuilder.RequestTypes = Object.freeze({
    "Permanent" : "Permanent", "Temporary" : "Temporary"});

SPLM.Validate.OverrideBuilder.ToStates = Object.freeze({
    "Passed" : "Passed", "Failed" : "Failed"});

SPLM.Validate.OverrideBuilder.DecisionActions = Object.freeze({
    "Approved" : "Approved", "Rejected" : "Rejected", "Pending" : "Pending"});

export default SPLM;